import { X, CheckCircle, AlertCircle, Info } from "lucide-react";
import { useToast } from "../../context/ToastContext";

const icons = {
  success: <CheckCircle size={18} className="text-green-600 shrink-0" />,
  error:   <AlertCircle size={18} className="text-rauxa shrink-0" />,
  info:    <Info size={18} className="text-blue-600 shrink-0" />,
};

function ToastItem({ toast }) {
  const { removeToast } = useToast();
  return (
    <div className="flex items-start gap-3 bg-white border border-border rounded-2xl shadow-card px-4 py-3 min-w-[280px] max-w-sm animate-slide-up">
      {icons[toast.type] ?? icons.info}
      <span className="text-sm text-dark flex-1 leading-snug">{toast.message}</span>
      <button onClick={() => removeToast(toast.id)} className="text-muted hover:text-dark transition-colors ml-1 shrink-0">
        <X size={16} />
      </button>
    </div>
  );
}

export default function ToastContainer() {
  const { toasts } = useToast();
  if (!toasts.length) return null;
  return (
    <div className="fixed bottom-6 right-6 z-[200] flex flex-col gap-2 items-end">
      {toasts.map(t => <ToastItem key={t.id} toast={t} />)}
    </div>
  );
}
